import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { staffDirectoryRoute } from '@townsquare/routes/staff-directory-view';

import { staffDirectoryResource } from './resources';

// Staff Directory View
const StaffDirectoryLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "RelayStaffDirectory" */ './components/StaffDirectoryView'),
  loading: () => null, // DirectorySkeleton, - TODO need to redo the skeleton, in its current form it will blow up our main bundle size
  delay: 0,
});

staffDirectoryRoute.component = StaffDirectoryLoadable;
staffDirectoryRoute.resources = [onboardingResource, staffDirectoryResource];
export const staffDirectoryRouterRoute = staffDirectoryRoute;
